export default {"src":"/_next/static/media/arrow-right.dcdf58ff.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};